import { render } from "./MiBackBtn.vue?vue&type=template&id=59e2f770"
import script from "./MiBackBtn.vue?vue&type=script&lang=js"
export * from "./MiBackBtn.vue?vue&type=script&lang=js"

import "./MiBackBtn.vue?vue&type=style&index=0&id=59e2f770&lang=scss"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__